export const products = [
  {
    id: 'product-1',
    name: 'Dickies Lined Eisenhower Jacket',
    image: 'https://via.placeholder.com/240x240.png?text=Dickies+Jacket',
    price: 159,
    tags: ['t-shirt', 'indigo', 'white']
  },
  {
    id: 'product-2',
    name: 'Nike ACG Wolf Tree Full Zip Fleece',
    image: 'https://via.placeholder.com/240x240.png?text=Nike+ACG+Fleece',
    price: 265,
    tags: ['t-shirt', 'indigo', 'white']
  },
  {
    id: 'product-3',
    name: 'Barbour SL Spey Showerproof Jacket',
    image: 'https://via.placeholder.com/240x240.png?text=Barbour+Jacket',
    price: 309,
    tags: ['t-shirt', 'indigo', 'white']
  },
  {
    id: 'product-4',
    name: 'Polo Ralph Lauren Windbreaker Harrington',
    image: 'https://via.placeholder.com/240x240.png?text=Polo+Ralph+Lauren',
    price: 329,
    tags: ['t-shirt', 'indigo', 'white']
  },
  {
    id: 'product-5',
    name: 'Carhartt WIP Detroit Jacket',
    image: 'https://via.placeholder.com/240x240.png?text=Carhartt+WIP',
    price: 409,
    tags: ['t-shirt', 'indigo', 'white']
  },
  {
    id: 'product-6',
    name: 'Daily Paper Jacob Denim Jacket',
    image: 'https://via.placeholder.com/240x240.png?text=Daily+Paper',
    price: 319,
    tags: ['t-shirt', 'indigo', 'white']
  },
  {
    id: 'product-7',
    name: 'Montane Spirit Gore-Tex Jacket',
    image: 'https://via.placeholder.com/240x240.png?text=Montane+Spirit',
    price: 385,
    tags: ['t-shirt', 'indigo', 'white']
  },
  {
    id: 'product-8',
    name: 'Nike x NOCTA Cardinal Stock Woven Track Jacket',
    image: 'https://via.placeholder.com/240x240.png?text=Nike+NOCTA',
    price: 229,
    tags: ['t-shirt', 'indigo', 'white']
  }
];
